module.exports = __webpack_public_path__ + "img/hold.3b3fa06a.png";